(function(){
  const root = document.querySelector('[data-am-root]');
  if(!root) return;

  const LAUNCH_DATE = new Date(root.dataset.launchDate || Date.now());
  let revealCountdown = root.dataset.revealCountdown === 'true';

  /* ============ EARLY ACCESS — Omnisend custom-trigger popup ============ */
  const openFormBtn = root.querySelector('[data-am-open-form]');
  if(openFormBtn){
    const formId = openFormBtn.dataset.omnisendFormId;
    openFormBtn.addEventListener('click', function(){
      if(!formId){
        console.warn('ASCEND: Omnisend form ID has not been configured.');
        return;
      }
      if(typeof window.omnisend === 'undefined' || Array.isArray(window.omnisend)){
        console.warn('ASCEND: Omnisend\'s script does not appear to be loaded on this page yet.');
      }
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', formId]);
    });
  }

  /* ============ ENTRANCE ============ */
  function runEntrance(){
    const seq = [
      ['.am-topbar', 0],
      ['.am-emblem-wrap', 120],
      ['.am-wordmark', 500],
      ['.am-tagline', 620],
      ['.am-countdown', 720],
      ['.am-cta', 840],
      ['.am-scroll-hint', 960],
    ];
    seq.forEach(([sel, delay])=>{
      const el = root.querySelector(sel);
      if(!el) return;
      el.style.transition = 'none';
      el.style.opacity = 0;
      el.style.transform = sel === '.am-emblem-wrap' ? 'scale(0.94)' : 'translateY(10px)';
      requestAnimationFrame(()=>{
        setTimeout(()=>{
          el.style.transition = 'opacity 0.75s cubic-bezier(.22,.61,.36,1), transform 0.75s cubic-bezier(.22,.61,.36,1)';
          el.style.opacity = sel === '.am-scroll-hint' ? 0.5 : 1;
          el.style.transform = 'translateY(0) scale(1)';
        }, delay);
      });
    });
  }
  runEntrance();

  /* ============ COUNTDOWN ============ */
  const units = [
    {id:'days', label:'DAYS'},
    {id:'hours', label:'HOURS'},
    {id:'minutes', label:'MINUTES'},
    {id:'seconds', label:'SECONDS'},
  ];
  const countdownEl = root.querySelector('[data-am-countdown]');
  const charEls = {};

  units.forEach(u=>{
    const unit = document.createElement('div');
    unit.className = 'am-cd-unit';
    const digits = document.createElement('div');
    digits.className = 'am-cd-digits';
    const c1 = makeChar(); const c2 = makeChar();
    digits.appendChild(c1); digits.appendChild(c2);
    const label = document.createElement('div');
    label.className = 'am-cd-label';
    label.textContent = u.label;
    unit.appendChild(digits); unit.appendChild(label);
    countdownEl.appendChild(unit);
    charEls[u.id] = [c1, c2];
  });

  function makeChar(){
    const wrap = document.createElement('div');
    wrap.className = 'am-cd-char';
    const slot = document.createElement('div');
    slot.className = 'am-slot';
    slot.textContent = '?';
    wrap.appendChild(slot);
    wrap._current = '?';
    return wrap;
  }

  function rollChar(el, newVal){
    if(el._current === newVal && revealCountdown) return;
    el._current = newVal;
    const outgoing = el.querySelector('.am-slot');
    const incoming = document.createElement('div');
    incoming.className = 'am-slot am-enter';
    incoming.textContent = newVal;
    el.appendChild(incoming);
    requestAnimationFrame(()=>{
      outgoing.style.transition = 'transform .55s cubic-bezier(.5,0,.2,1), opacity .5s ease';
      incoming.style.transition = 'transform .55s cubic-bezier(.5,0,.2,1)';
      outgoing.style.transform = 'translateY(-100%)';
      outgoing.style.opacity = '0.15';
      incoming.style.transform = 'translateY(0)';
    });
    setTimeout(()=>{ outgoing.remove(); }, 600);
  }

  function getRemaining(){
    const diff = Math.max(0, LAUNCH_DATE - Date.now());
    const s = Math.floor(diff/1000)%60;
    const m = Math.floor(diff/60000)%60;
    const h = Math.floor(diff/3600000)%24;
    const d = Math.floor(diff/86400000);
    return {
      days: String(Math.min(d,99)).padStart(2,'0'),
      hours: String(h).padStart(2,'0'),
      minutes: String(m).padStart(2,'0'),
      seconds: String(s).padStart(2,'0'),
    };
  }

  let lastVals = {days:null,hours:null,minutes:null,seconds:null};

  function tickReveal(){
    const vals = getRemaining();
    units.forEach(u=>{
      const val = vals[u.id];
      if(lastVals[u.id] !== val){
        const [d1,d2] = charEls[u.id];
        const prev = lastVals[u.id];
        if(!prev || prev[0] !== val[0]) rollChar(d1, val[0]);
        if(!prev || prev[1] !== val[1]) rollChar(d2, val[1]);
        lastVals[u.id] = val;
      }
    });
    if(LAUNCH_DATE - Date.now() <= 0){
      countdownEl.innerHTML = '';
      const done = document.createElement('div');
      done.className = 'am-tagline';
      done.style.marginTop = '4px';
      done.textContent = 'THE COLLECTIVE HAS ARRIVED';
      countdownEl.appendChild(done);
    }
  }
  setInterval(()=>{ if(revealCountdown) tickReveal(); }, 1000);
  if(revealCountdown) tickReveal();

  const mysteryTargets = ['days-0','days-1','hours-0','hours-1','minutes-0','minutes-1','seconds-0','seconds-1'];
  function scheduleMysteryRoll(){
    if(revealCountdown) return;
    const pick = mysteryTargets[Math.floor(Math.random()*mysteryTargets.length)];
    const [unit, idx] = pick.split('-');
    const el = charEls[unit][Number(idx)];
    rollChar(el, '?');
    el._current = null;
    const nextDelay = 900 + Math.random()*2200;
    setTimeout(scheduleMysteryRoll, nextDelay);
  }
  setTimeout(scheduleMysteryRoll, 1400);

  /* ============ 3D EMBLEM — GLB, PMREM studio environment, PBR bronze ============ */
  const wrap = root.querySelector('[data-am-emblem]');
  const canvas = root.querySelector('[data-am-canvas]');
  const fallback = root.querySelector('[data-am-fallback]');
  const MODEL_URL = root.dataset.modelUrl;

  let renderer, scene, camera, rotationGroup, envTexture;
  let dragging = false;
  let lastX = 0, lastY = 0;
  let velX = 0, velY = 0;
  const SENSITIVITY = 0.009;
  const DAMPING = 0.945;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let destroyed = false;

  /*
   * Procedural studio environment. No external HDR: we build a small offline
   * scene of unlit "softbox" panels — one large bright vertical panel upper
   * right, a softer front-left fill, a narrow bright strip that produces the
   * traveling rim highlight along the curved edge, and dark surrounding walls
   * for contrast — then bake it with PMREMGenerator into a real reflection
   * environment. Because this is assigned to scene.environment (not parented
   * to the rotating coin), the reflections stay fixed in world space and
   * sweep across the metal naturally as the coin turns underneath them.
   */
  function buildStudioEnvironment(renderer){
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    pmremGenerator.compileCubemapShader();

    const envScene = new THREE.Scene();
    envScene.background = new THREE.Color(0x040302);

    function panel(w, h, color, intensity, x, y, z){
      const geo = new THREE.PlaneGeometry(w, h);
      const mat = new THREE.MeshBasicMaterial({ color: color, toneMapped: false, side: THREE.DoubleSide });
      const mesh = new THREE.Mesh(geo, mat);
      mesh.material.color.multiplyScalar(intensity);
      mesh.position.set(x, y, z);
      mesh.lookAt(0, 0, 0);
      envScene.add(mesh);
    }

    // large vertical bright softbox, upper right — the main "long flowing highlight"
    panel(6, 16, 0xfff2d6, 3.4, 8, 6, 3);
    // softer, larger fill from the front-left
    panel(11, 11, 0xcfd7e4, 0.85, -9, 0.5, 5);
    // narrow bright strip that catches the curved rim as it rotates
    panel(1, 18, 0xffe7bd, 4.8, 5.5, -0.5, -8.5);
    // low warm bounce card beneath, keeps the underside from going pure black
    panel(9, 4, 0x2a1c10, 0.55, 0, -7.5, 4);
    // dim cool card behind, separates the rim from the black background
    panel(10, 10, 0x141821, 0.4, -2, -1, -10);

    const rt = pmremGenerator.fromScene(envScene, 0.035);
    pmremGenerator.dispose();
    return rt.texture;
  }

  function initScene(){
    if(destroyed) return;
    if(typeof THREE === 'undefined' || typeof THREE.GLTFLoader === 'undefined'){
      console.warn('ASCEND: THREE/GLTFLoader not available, static fallback shown');
      return;
    }
    const w = wrap.clientWidth, h = wrap.clientHeight;

    renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
    renderer.setClearColor(0x000000, 0);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(w, h);
    if(renderer.outputEncoding !== undefined) renderer.outputEncoding = THREE.sRGBEncoding;
    if(renderer.physicallyCorrectLights !== undefined) renderer.physicallyCorrectLights = true;

    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(32, w / h, 0.1, 100);
    camera.position.set(0, 0, 6);

    if(renderer.toneMapping !== undefined){
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.08;
    }

    // Procedural PMREM studio environment supplies the realistic moving
    // reflections; a couple of soft directional lights remain to shape form
    // and keep the underside of the coin from disappearing into shadow.
    envTexture = buildStudioEnvironment(renderer);
    scene.environment = envTexture;

    const key = new THREE.DirectionalLight(0xffdca0, 1.1);
    key.position.set(-3, 5, 5);
    const rim = new THREE.DirectionalLight(0xffe9c8, 0.5);
    rim.position.set(-2, -3, -5);
    const ambient = new THREE.AmbientLight(0x100c07, 0.35);
    scene.add(key, rim, ambient);

    rotationGroup = new THREE.Group();
    scene.add(rotationGroup);

    const loader = new THREE.GLTFLoader();
    loader.load(
      MODEL_URL,
      (gltf) => {
        if(destroyed) return;
        const model = gltf.scene;

        model.traverse((child) => {
          if(child.isMesh){
            if(child.geometry){
              // Weld duplicate vertices left over from export (these are what
              // split the surface into visibly separate facets), then rebuild
              // normals across the merged surface so shading reads as one
              // continuous smooth curve rather than a faceted low-poly ring.
              if(THREE.BufferGeometryUtils && THREE.BufferGeometryUtils.mergeVertices){
                try {
                  child.geometry = THREE.BufferGeometryUtils.mergeVertices(child.geometry, 1e-4);
                } catch(e) {
                  console.warn('ASCEND: vertex merge failed, continuing with original geometry', e);
                }
              }
              child.geometry.computeVertexNormals();
            }
            const isMark = /mark|diamond/i.test(child.name || '');
            child.material = new THREE.MeshPhysicalMaterial({
              color: isMark ? 0x3c2f1a : 0x2e2313,
              metalness: 1,
              roughness: isMark ? 0.24 : 0.29,
              envMapIntensity: 1.7,
              clearcoat: 0.35,
              clearcoatRoughness: 0.13,
              side: THREE.DoubleSide,
              flatShading: false,
            });
          }
        });

        const box = new THREE.Box3().setFromObject(model);
        const center = box.getCenter(new THREE.Vector3());
        const size = box.getSize(new THREE.Vector3());
        model.position.sub(center);
        const maxDim = Math.max(size.x, size.y, size.z) || 1;
        const desiredSize = 3.4;
        model.scale.setScalar(desiredSize / maxDim);

        rotationGroup.add(model);

        animate();
        requestAnimationFrame(() => {
          canvas.classList.add('am-ready');
          setTimeout(() => { fallback.classList.add('am-hide'); }, 400);
        });
      },
      undefined,
      (err) => {
        console.warn('ASCEND: failed to load 3D model, static fallback shown', err);
      }
    );
  }

  function animate(){
    if(destroyed || !rotationGroup) return;
    requestAnimationFrame(animate);

    if(!dragging){
      velX *= DAMPING;
      velY *= DAMPING;
    }

    if(!prefersReduced && (Math.abs(velX) > 0.00001 || Math.abs(velY) > 0.00001)){
      const qY = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(0, 1, 0), velX);
      const qX = new THREE.Quaternion().setFromAxisAngle(new THREE.Vector3(1, 0, 0), velY);
      rotationGroup.quaternion.premultiply(qY);
      rotationGroup.quaternion.multiply(qX);
      rotationGroup.quaternion.normalize();
    }

    renderer.render(scene, camera);
  }

  function onDown(x, y, pointerId){
    dragging = true;
    lastX = x; lastY = y;
    wrap.classList.add('am-grabbing');
    if(pointerId !== undefined){
      try { wrap.setPointerCapture(pointerId); } catch(e){}
    }
  }
  function onMove(x, y){
    if(!dragging) return;
    const dx = x - lastX, dy = y - lastY;
    velX = dx * SENSITIVITY;
    velY = dy * SENSITIVITY;
    lastX = x; lastY = y;
  }
  function onUp(){
    dragging = false;
    wrap.classList.remove('am-grabbing');
  }

  wrap.addEventListener('pointerdown', (e) => onDown(e.clientX, e.clientY, e.pointerId));
  wrap.addEventListener('pointermove', (e) => onMove(e.clientX, e.clientY));
  window.addEventListener('pointerup', onUp);
  wrap.addEventListener('pointercancel', onUp);

  window.addEventListener('resize', () => {
    if(!renderer || !camera) return;
    const w = wrap.clientWidth, h = wrap.clientHeight;
    renderer.setSize(w, h);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  });

  document.addEventListener('shopify:section:unload', function handler(e){
    if(e.target && e.target.contains && e.target.contains(root)){
      destroyed = true;
      if(renderer){ renderer.dispose(); }
      if(envTexture){ envTexture.dispose(); }
      window.removeEventListener('pointerup', onUp);
      document.removeEventListener('shopify:section:unload', handler);
    }
  });

  initScene();
})();
